import { useEffect, useRef, useState } from 'react';
import { SOURCE_GROUPS, type SourceGroup } from './columnRegistry';

/** The `i` affordance: click for where a column's values come from. */
export function InfoDot({ title, detail, group }: { title: string; detail: string; group: SourceGroup }) {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLSpanElement>(null);

    // Click-outside and Escape both close it — a pinned popover that survives
    // the next click is worse than no popover.
    useEffect(() => {
        if (!open) return;
        const onDown = (e: MouseEvent) => {
            if (!ref.current?.contains(e.target as Node)) setOpen(false);
        };
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    return (
        <span className="aq-info-wrap" ref={ref}>
            <button
                type="button"
                className="aq-info"
                aria-expanded={open}
                aria-label={`Where "${title}" comes from`}
                onClick={() => setOpen(v => !v)}
            >
                i
            </button>
            {open && (
                <span className={`aq-pop aq-src-${group}`} role="tooltip">
                    <b>{title}</b>
                    <span className="aq-pop-group">{SOURCE_GROUPS[group].label}</span>
                    {detail}
                </span>
            )}
        </span>
    );
}
